export { generateFullPageMetadata } from './MetaHead';